import JSZip from 'jszip';

export interface ZipExtractResult {
  urdfContent: string;
  meshBlobUrls: Map<string, string>;
  urdfFileName: string;
}

export async function extractRobotZip(file: File): Promise<ZipExtractResult> {
  const zip = await JSZip.loadAsync(file);
  const meshBlobUrls = new Map<string, string>();

  // Find the URDF file
  let urdfContent = '';
  let urdfFileName = '';

  for (const [path, entry] of Object.entries(zip.files)) {
    if (entry.dir) continue;
    const lowerPath = path.toLowerCase();

    if (lowerPath.endsWith('.urdf')) {
      urdfContent = await entry.async('text');
      urdfFileName = path.split('/').pop() || path;
    } else if (
      lowerPath.endsWith('.stl') ||
      lowerPath.endsWith('.dae') ||
      lowerPath.endsWith('.obj') ||
      lowerPath.endsWith('.png') ||
      lowerPath.endsWith('.jpg') ||
      lowerPath.endsWith('.jpeg') ||
      lowerPath.endsWith('.tga')
    ) {
      const blob = await entry.async('blob');
      const blobUrl = URL.createObjectURL(blob);
      // Store under multiple keys for lookup flexibility
      meshBlobUrls.set(path, blobUrl);
      const basename = path.split('/').pop() || path;
      if (!meshBlobUrls.has(basename)) {
        meshBlobUrls.set(basename, blobUrl);
      }
    }
  }

  if (!urdfContent) {
    throw new Error('No .urdf file found in ZIP');
  }

  return { urdfContent, meshBlobUrls, urdfFileName };
}

export function revokeBlobUrls(urls: Map<string, string>): void {
  const revoked = new Set<string>();
  urls.forEach((url) => {
    if (!revoked.has(url)) {
      URL.revokeObjectURL(url);
      revoked.add(url);
    }
  });
  urls.clear();
}
